import { isDeviceOutputMobileOrMobileApp } from "../../Domain/DeviceOutputState";
import { useWindowSize } from "./useWindowSize";

export function useMobile() {
    const { isMobileScreenSizeFlag } = useWindowSize();
    return {
        isMobile: isDeviceOutputMobileOrMobileApp() || isMobileScreenSizeFlag,
    };
}
